import React, { createContext, useContext, useEffect } from 'react';
import { ConfigProvider, Empty } from 'antd';
import moment from 'moment';
import numeral from 'numeral';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import frFR from 'antd/lib/locale/fr_FR';
import enGB from 'antd/lib/locale/en_GB';
import esES from 'antd/lib/locale/es_ES';
import deDE from 'antd/lib/locale/de_DE';
import { useReducerWithSessionStorage } from '../utils';
import en_GB from '../locales/en_GB';
import fr_FR from '../locales/fr_FR';
import es_ES from '../locales/es_ES';
import de_DE from '../locales/de_DE';
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/de';
import 'numeral/locales/fr';
import 'numeral/locales/es';
import 'numeral/locales/de';

const locales = {
  fr_FR: frFR,
  en_GB: enGB,
  es_ES: esES,
  de_DE: deDE
};

moment.locale('fr');
numeral.locale('fr');

numeral.register('format', 'siren', {
  regexps: { format: /(siren)/ },
  format: (value) => {
    const str = Object.values(`${value}`);
    let output = '';
    let count = 0;

    str.forEach((c) => {
      if (count % 3 === 0) output += ' ';
      output += c;
      count += 1;
    });
    return output;
  }
});

const customizeRenderEmpty = () => <Empty />;

i18n.use(initReactI18next).init({
  resources: {
    en_GB,
    fr_FR,
    es_ES,
    de_DE
  },
  lng: 'fr_FR',
  fallbackLng: 'fr_FR',
  interpolation: {
    escapeValue: false
  }
});

const LanguageContext = createContext({});

const localeReducer = (state, action) => {
  if (action.type === 'SET_LOCALE') {
    if (locales[action.locale]) {
      const shortLocale = action.locale.split('_')[0];

      moment.locale(shortLocale);
      numeral.locale(shortLocale);
      i18n.changeLanguage(action.locale);
      return action.locale;
    }
  }
  return state;
};

export const LanguageContextProvider = ({ children }) => {
  const [locale, dispatch] = useReducerWithSessionStorage(
    'locale',
    localeReducer,
    'fr_FR'
  );

  useEffect(() => {
    dispatch({ type: 'SET_LOCALE', locale });
  }, [locale, dispatch]);

  return (
    <LanguageContext.Provider value={{ locale, dispatch }}>
      <ConfigProvider
        locale={locales[locale]}
        renderEmpty={customizeRenderEmpty}
      >
        {children}
      </ConfigProvider>
    </LanguageContext.Provider>
  );
};

export default () => useContext(LanguageContext);
